import { EventRepository } from '../../domain/repository';
import { EventRepositoryImpl } from '../repository';

export const eventProviders = [
  {
    provide: EventRepository,
    useExisting: EventRepositoryImpl,
  },
];


